import { createRouter } from '@tanstack/react-router';

import { routeTree } from '@/routeTree.gen';
import { ContentRouteErrorComponent } from '@/components/content-route-error-component';
import { NotFoundComponent } from '@/components/not-found-component';

const router = createRouter({
  routeTree,
  defaultPreloadStaleTime: 0,
  scrollRestoration: true,
  defaultErrorComponent: ContentRouteErrorComponent,
  defaultNotFoundComponent: NotFoundComponent,
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

export default router;
